class Timeline {
    constructor () {
        this.timeSlider();
    }
    timeSlider() {
        var mySlider;

        if( $('#timeline-slider .field--name-field-timeline').length ){
            mySlider = '#timeline-slider .field--name-field-timeline';
        } else {
            mySlider = '#timeline-slider .field--name-field-historique';
        }

        $('#menu-timeline-slider').slick({
            slidesToShow: 6,
            dots: false,
            arrows: false,
            infinite: false,
            asNavFor: mySlider,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3,
                        centerMode: true,
                    }
                },
                {
                    breakpoint: 980,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                    }
                },
            ]
        });

        $(mySlider).slick({
            slidesToShow: 1,
            dots: false,
            infinite: false,
            asNavFor: '#menu-timeline-slider',
            arrows: false,
            responsive: [
                {
                    breakpoint: 980,
                    settings: {
                        arrows: true,
                    }
                }
            ]
        });
    }
}

export default Timeline;